import { postApiCaller } from "../apiCaller";

export const login = async (payload) => {
    const response = await postApiCaller("user/login", payload);
    return response;
};

